export type Payload =
  | {
      time: number;
      blocks: Block[];
      version: string;
    }
  | {
      provider: string;
      url: string;
    };
export interface Author {
  id: string;
  name: string;
  avatar: string;
  title: string;
  bio: string;
  isVerified: boolean;
  isFollowing: boolean;
  socialMediaLinks: string[];
}

export interface Segment {
  group: string;
  code: string;
  name: string;
}

export interface Block {
  id: string;
  type:
    | "paragraph"
    | "header"
    | "quote"
    | "embed"
    | "list"
    | "linkTool"
    | "extendedImage"
    | "product-group"
    | "delimiter"
    | "table";
  data: any;
}
export interface BaseContent {
  viewCount: number;
  isLiked: boolean;
  isSaved: boolean;
  isCompleted: boolean;
  id: string;
  status: number;
  title: string;
  slug: string;
  lead: string;
  summary: string;
  thumbnailUrl: string;
  coverImageUrl: string;
  publishedAt: string;
  enableComment: boolean;
  likeCount: number;
  commentCount: number;
  meta: Meta;
  seo: Seo;
  taxonomy: Taxonomy;
  settings: Settings;
  resources: Resources;
  timeline: Timeline;
  linkedQuizContentId: string | null;
  linkedQuizContent: any;
  author: Author;
  categories: any[];
  segments: Segment[];
}

export enum ContentType {
  Article = 0,
  Video = 1,
  Quiz = 2,
  Product = 3,
  Carousel = 4,
  MiniQuiz = 5,
}

export type Question = {
  id: string;
  image: string;
  options: { id: string; label: string; image: string; resultIds: string[] }[];
  text: string;
  weight: number;
  type: "single-choice" | "multiple-choice" | "image" | "true-false";
};
export type QuizResult = {
  id: string;
  title: string;
  description: string;
  image: string;
};
export type QuestionPayload = {
  questions: Question[];
  results: QuizResult[];
  shuffleOptions: boolean;
  shuffleQuestions: boolean;
};

export type Content =
  | (BaseContent & {
      type: ContentType.Article | ContentType.Product;
      payload: {
        time: number;
        blocks: Block[];
        version: string;
      };
    })
  | (BaseContent & {
      type: ContentType.Video;
      payload: {
        provider: string;
        url: string;
      };
    })
  | (BaseContent & {
      type: ContentType.Quiz;
      payload: QuestionPayload;
    });

export interface Meta {
  title: string;
  slug: string;
  lead: string;
  summary: string;
  thumbnailUrl: string;
  coverImageUrl: string;
}

export interface Seo {
  title: string;
  description: string;
  keywords: string[];
  canonicalUrl?: string;
}

export interface Taxonomy {
  segments: string[];
  pregnancyPeriod: any[];
  babyPeriod: any[];
  categories: any[];
}

export interface Settings {
  enableComment: boolean;
  enableContentList: boolean;
  readingTimeMinutes: string;
}

export interface Resources {
  references: any[];
  products: any[];
}

export interface CreatedBy {
  id: string;
  name: string;
  avatar: string;
}

export interface LastEditedBy {
  id: string;
  name: string;
  avatar: string;
}

export interface ApprovedBy {
  id: string;
  name: string;
  avatar: string;
}

export interface Timeline {
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  publishAt: string;
}

export interface Author {
  id: string;
  name: string;
  avatar: string;
  title: string;
  bio: string;
  isVerified: boolean;
  isFollowing: boolean;
  socialMediaLinks: string[];
}

export interface Comment {
  id: string;
  contentId: string;
  userId: string;
  userName: string;
  userAvatar: string;
  userTitle: string;
  isVerified: boolean;
  isEdited: boolean;
  isOwner: boolean;
  text: string;
  imageUrls: string[];
  createdAt: string;
  createdAtLabel: string;
  likeCount: number;
  isLiked: boolean;
  replyCount: number;
  userActionUrl: string;
  userActionSlugUrl: string;
}
